<div class="p-0 m-0 relative">

  <div class="h-full flex flex-col mt-2">

    <!-- Code de validation : affiché UNIQUEMENT si l'utilisateur n'est PAS authentifié -->
    @if (!isUserAuthenticated() || !isUserAuthorized()) {
    <app-validation-code ($codeGenerated)="codeGenerated($event)"
      [EntityInstance]="editingEntity()?.validationCode ?? null"
      ($dataChanged)="dataChanged($event)"
      ($validationSuccess)="validationSuccess($event)">
    </app-validation-code>
    }

    <!-- 2. Contenu principal après authentification -->
    @if (isUserAuthenticated() && isUserAuthorized()) {

    <!-- === MODE CHECKIN === -->
    @if (componentMode() === 'checkin') {


    <!-- Message de bienvenue après entrée réussie -->
    @if (entrySiteSuccess()) {
    <div class="text-gray-100 p-4 border border-green-900 rounded bg-green-500 text-center mt-4 text-2xl">
      <i class="fa-solid fa-face-smile text-xl ml-2"></i>
      {{ 'vues.qr-code.checkin-form.welcome-site' | translate }}
    </div>

    <div class="mt-6 px-4">
      <button type="button"
        (click)="goToCheckout()"
        class="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-6 rounded-lg shadow-lg transition duration-200 flex items-center justify-center gap-3 text-lg">
        <i class="fa-solid fa-arrow-right-from-bracket text-2xl"></i>
        {{ 'buttons.go-to-checkout' | translate }}
      </button>
    </div>
    } @else {

    <div class="flex-grow m-0 p-0 sm:p-4 min-w-[320px]">

      <div class="mb-6">
        <h1 class="text-[16px] [@media(min-width:640px)]:text-xl font-semibold mb-3">
          {{ 'vues.qr-code.checkin-form.stack-list-title' | translate }}
        </h1>

        <div class="border rounded-md p-4 pb-[1em] bg-gray-50 min-h-[150px] relative">

          <!-- Liste des activités existantes -->
          @if (!noActivityFound()) {
          <app-trucker-activity-stack-list [isNested]="true"
            [showCreateButton]="false"
            [fkPointOfServiceId]="matwinsVariables.posId ? +matwinsVariables.posId : null"
            [nestedData]="activities()"
            (activitySelected)="onActivitySelected($event)"
            (itemSaved)="onActivityDetailSaved($event)">
          </app-trucker-activity-stack-list>
          }

          <!-- Message "Aucune activité correspondante" -->
          @if (noActivityFound()) {
          <div class="text-blue-800 font-bold p-2 border border-blue-500 rounded bg-blue-100 text-center mt-3 text-base">
            <i class="fa-solid fa-magnifying-glass-minus text-blue-600 text-3xl -ml-5 mr-4"></i>
            {{ 'vues.qr-code.checkin-form.no-fit-message' | translate }}
          </div>
          }

          <!-- Bouton flottant "Créer nouvelle activité" -->
          <!--<label class="absolute bottom-6 right-[10.5%] [@media(min-width:900px)]:right-[50.2%] -translate-x-[20%]">{{ 'Ajouter une nouvelle activite' | translate }} </label>-->

          <button (click)="onCreateNewActivity()"
            class=" relative w-[100%] mt-6 bottom-4 font-bold  bg-blue-600 text-white rounded p-3 shadow-lg hover:bg-blue-700 focus:outline-none">
            <i class="fa-solid fa-circle-plus text-blue-100 text-3xl -ml-[13%] mr-[6%]"></i>
            {{ 'vues.qr-code.checkin-form.add-activity' | translate }}
            <!--<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 absolute top-1/2 -translate-y-1/2 left-1/4 font-bold" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>-->

          </button>

        </div>
      </div>

      <!-- Sélection profil + détail activité + bouton entrée (seulement si une activité est sélectionnée ou en création) -->
      @if (isActivitySelected() || isNewActivity()) {

      <!-- Dropdown Sélection Profil -->
      <div class="mb-6">
        <label for="profile-select" class="block text-sm font-medium text-gray-700 mb-2">
          {{ 'vues.qr-code.checkin-form.select-profile' | translate }}
        </label>
        <select id="profile-select" class="{{Skin.formInputSmallSize}} block w-full"
          [(ngModel)]="selectedTruckerId" (change)="onTruckerSelected($event)">
          <option [value]="null" disabled>{{ 'choose-a-profile' | translate }}</option>
          @for (profileOption of profiles(); track profileOption.id) {
          <option [value]="profileOption.id">{{ profileOption.fullName }}</option>
          }
          <option value="new-profile">{{ 'new-profile' | translate }}</option>
        </select>
      </div>

      @if (selectedTruckerId) {
      <!-- Détail de l'activité -->
      <div class="m-0 w-[100%] h-[100%] -top-5 -left-[20px] z-[999] rounded-md">
        <qr-code-activity-detail #truckerActivityDetail
          [isModal]="true"
          [EntityInstance]="selectedActivity()"
          [fkPointOfServiceId]="fkPointOfServiceId"
          [createNewProfile]="createNewProfile()"
          [CanEdit]="componentMode() !== 'checkout'">
        </qr-code-activity-detail>
      </div>

      <app-upload-document (filesChanged)="filesChanged($event)"></app-upload-document>

      <!-- Bouton "Entrer sur le site" -->
      <div class="p-0 bg-white shadow-md mt-6">
        <button type="button" (click)="onEnterSite()"
          class="w-full bg-blue-600 text-white rounded-lg p-3 shadow-lg hover:bg-blue-700 focus:outline-none">
          {{ 'buttons.enter-site' | translate }}
        </button>
      </div>
      }
      }

    </div>
    }
    }

    @else if (componentMode() === 'edit') {
    <!-- Message de sortie réussie -->
    @if (editSiteSuccess()) {
    <div class="text-gray-100 p-4 border border-green-900 rounded bg-green-500 text-center mt-4 text-2xl font-bold">
      <i class="fa-solid fa-handshake text-3xl -ml-[13%] mr-[6%]"></i>

      {{ 'vues.qr-code.edit-form.edited-site' | translate }}
    </div>
    } @else {
    <!-- Détail de l'activité -->
    <div class="m-0 w-[100%] h-[100%] -top-5 -left-[20px] z-[999] rounded-md">
      <qr-code-activity-detail #truckerActivityDetail
        [isModal]="true"
        [EntityInstance]="selectedActivity()"
        [fkPointOfServiceId]="fkPointOfServiceId"
        [createNewProfile]="createNewProfile()"
        [CanEdit]="true">
      </qr-code-activity-detail>
    </div>
    <app-download-document [attachments]="$safeNavigationMigration(selectedActivity()?.attachments)" [columns]="5"></app-download-document>

    <app-upload-document (filesChanged)="filesChanged($event)"></app-upload-document>

    <!-- Bouton "Entrer sur le site" -->
    <div class="p-0 bg-white shadow-md mt-6">
      <button type="button" (click)="onEditSubmit()"
        class="w-full bg-blue-600 text-white rounded-lg p-3 shadow-lg hover:bg-blue-700 focus:outline-none">
        {{ 'buttons.enter-site' | translate }}
      </button>
    </div>
    }
    }

    <!-- === MODE CHECKOUT === -->
    @else if (componentMode() === 'checkout') {

    <!-- Message de sortie réussie -->
    @if (exitSiteSuccess()) {
    <div class="text-gray-100 p-4 border border-green-900 rounded bg-green-500 text-center mt-4 text-2xl font-bold">
      <i class="fa-solid fa-handshake text-3xl -ml-[13%] mr-[6%]"></i>

      {{ 'vues.qr-code.checkout-form.goodbye-site' | translate }}
    </div>
    } @else {

    <div class="flex-grow m-0 p-0 sm:p-4 min-w-[320px]">

      <div class="mb-6">
        <h1 class="text-[16px] [@media(min-width:640px)]:text-xl font-semibold mb-3">
          {{ 'vues.qr-code.checkout-form.stack-list-title' | translate }}
        </h1>

        <div class="border rounded-lg p-4 pb-[4.5em] bg-gray-50 min-h-[150px] relative">

          <!-- Liste des activités existantes -->
          @if (!noActivityFound()) {
          <app-trucker-activity-stack-list [isNested]="true"
            [showCreateButton]="false"
            [fkPointOfServiceId]="matwinsVariables.posId ? +matwinsVariables.posId : null"
            [nestedData]="activities()"
            (activitySelected)="onActivitySelected($event)"
            (itemSaved)="onActivityDetailSaved($event)">
          </app-trucker-activity-stack-list>
          }

          <!-- Message "Aucune activité correspondante" -->
          @if (noActivityFound()) {
          <div class="text-blue-800 font-bold p-2 border border-blue-500 rounded bg-blue-100 text-center mt-3 text-base">
            <i class="fa-solid fa-magnifying-glass-minus text-blue-600 text-3xl -ml-5 mr-4"></i>
            {{ 'vues.qr-code.checkout-form.no-fit-message' | translate }}
          </div>




          <!-- Bouton pour reprendre l'authentification -->
          <div class="mt-6">
            <button type="button" (click)="reAuthenticate()"
              class="w-full bg-blue-600 text-white rounded-lg p-3 shadow-lg hover:bg-blue-700 focus:outline-none">
              {{ 'buttons.re-authenticate' | translate }}
            </button>
          </div>
          }

        </div>
      </div>

      <!-- Détail de l'activité sélectionnée + bouton quitter -->
      @if (isActivitySelected()) {

      <div class="hidden">

        <!-- Détail de l'activité -->
        <div class="m-0 w-[100%] h-[100%] -top-5 -left-[20px] z-[999]">
          <qr-code-activity-detail #truckerActivityDetail
            [isModal]="true"
            [EntityInstance]="selectedActivity()"
            [fkPointOfServiceId]="fkPointOfServiceId"
            [createNewProfile]="createNewProfile()"
            [CanEdit]="componentMode() !== 'checkout'">
          </qr-code-activity-detail>
        </div>

        <app-upload-document (filesChanged)="filesChanged($event)"></app-upload-document>

      </div>


      <!-- Bouton "Quitter le site" -->
      <div class="p-0 bg-white shadow-md mt-6">
        <button type="button" (click)="onExitSite()"
          class="w-full bg-blue-500 text-white rounded-lg p-2 font-bold text-lg shadow-lg hover:bg-blue-700 focus:outline-none">
          <i class="fa-solid fa-person-walking-arrow-right text-blue-100 text-3xl -ml-[13%] mr-[6%]"></i>
          {{ 'buttons.exit-site' | translate }}
        </button>
      </div>
      }

    </div>
    }
    }

    }
    @else if(isUserAuthenticated() && !isUserAuthorized()) {
    <div class="text-red-600 text-center mt-4">
      {{ 'vues.qr-code.checkin-form.unauthorized-message' | translate }}
    </div>
    }

  </div>
</div>